import React from "react"
import { Link } from "gatsby"
import classes from "./Navbar.module.scss"

const Navbar = () => {
  return (
    <nav className={classes.Navbar}>
      <Link to="/" className={classes.Logo}>
        <p>roasted</p>
      </Link>
      <ul>
        <Link
          to="/recipes/sweet-potato-tacos"
          className={classes.NavLink}
          activeClassName={classes.navActive}
          getProps={({ location }) =>
            location.pathname.includes("recipes")
              ? { className: classes.navActive }
              : null
          }
        >
          recipes
        </Link>
        <Link
          to="/lifestyle/interview-melanie-passajou-dick"
          className={classes.NavLink}
          activeClassName={classes.navActive}
          getProps={({ location }) =>
            location.pathname.includes("lifestyle")
              ? { className: classes.navActive }
              : null
          }
        >
          lifestyle
        </Link>
        <Link
          to="/"
          className={classes.NavLink}
          activeClassName={classes.navActive}
        >
          about
        </Link>
      </ul>
    </nav>
  )
}

export default Navbar
